import { render, staticRenderFns } from "./AppPrice.vue?vue&type=template&id=258430a8&v-show=currency&"
import script from "./AppPrice.vue?vue&type=script&lang=js&"
export * from "./AppPrice.vue?vue&type=script&lang=js&"
import style0 from "./AppPrice.vue?vue&type=style&index=0&id=258430a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports